export const GET_SYSTEM_TYPE = 'GET_SYSTEM_TYPE';
export const SYSTEM_TYPE_UPDATED = 'SYSTEM_TYPE_UPDATED';